import updateConfirmList from './updateConfirmList';
import draftInvoice from './draftInvoice';
// import draftInoviceByFile from './draftInoviceByFile';
import updateSelectList from './updateSelectList';
import undraftInvoice from './undraftInvoice';
import updateCount from './updateCount';
import undraftInvoiceByUser from './undraftInvoiceByUser';

import AuthRecordList from './authRecordList';
import authRecordDetail from './authRecordDetail';
import authRecordLog from './authRecordLog';
import invoiceCommit from './InvoiceCommit';
import taxPeriod from './taxPeriod';
import changeTaxPeriod from './changeTaxPeriod';
import taxPeriodRefresh from './taxPeriodRefresh';
import getInvoiceDetail from './getInvoiceDetail';
import authLoggingList from './authLoggingList';
import addRest from './AddRest';
import saveRest from './SaveRest';
import ImgQuery from './imgQuery';
import selectAllDraft from './selectAllDraft';
import unselectAllDraft from './unselectAllDraft';
import downloadList from './downloadList';
export default {
    updateConfirmList,
    draftInvoice,
    // draftInoviceByFile,
    updateSelectList, 
    undraftInvoice,
    updateCount,
    undraftInvoiceByUser,  
    invoiceCommit,
    AuthRecordList,
    authRecordDetail,
    authRecordLog,
    taxPeriod,
    taxPeriodRefresh,
    getInvoiceDetail,
    authLoggingList,
    addRest,
    saveRest,
    ImgQuery,
    selectAllDraft,
    unselectAllDraft,
    downloadList,
    changeTaxPeriod
};



// WEBPACK FOOTER //
// ./src/api/authManage/index.ts